<template>
  <div>
    <v-dialog v-model="dialog" max-width="700" persistent>
      <v-card>
        <v-card-title> Nova Precificação </v-card-title>
        <v-card-text>
          <v-form v-model="valid" @submit.prevent>
            <v-row dense class="mx-0">
              <v-col cols="12">
                <v-text-field
                  v-model="precification.name"
                  label="Nome"
                  outlined
                  dense
                  :disabled="loading"
                  :rules="[(v) => !!v || 'Nome é obrigatório']"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="precification.dueDay"
                  label="Dia de vencimento"
                  type="number"
                  :min="1"
                  :max="28"
                  :step="1"
                  outlined
                  dense
                  :disabled="loading"
                  :rules="[
                    (v) => !!v || 'Vencimento é obrigatório',
                    (v) => v > 0 || 'Vencimento deve ser ou igual a 1',
                    (v) => v <= 28 || 'Vencimento deve ser menor ou igual a 28',
                  ]"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="precification.finePercentage"
                  label="Multa"
                  outlined
                  dense
                  suffix="%"
                  :disabled="loading"
                  :rules="[(v) => !!v || 'Multa é obrigatória']"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="precification.interestPercentage"
                  label="Juros"
                  outlined
                  dense
                  suffix="%"
                  :disabled="loading"
                  :rules="[(v) => !!v || 'Juros é obrigatório']"
                />
              </v-col>
              <v-col cols="12">
                <p class="text-subtitle-1 font-weight-bold">Regras</p>
                <PrecificationRulesController v-model="precification.rules" />
              </v-col>
            </v-row>
          </v-form>
          <v-alert v-if="error" type="error" dense text class="mt-4">
            {{ error }}
          </v-alert>
          <div class="d-flex mt-4">
            <v-btn @click="close" text> Cancelar </v-btn>
            <v-spacer />
            <v-btn
              @click="save"
              color="success"
              depressed
              :loading="loading"
              :disabled="!valid || precification.rules.length === 0"
            >
              Criar
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import COMPANY from "@/services/ultimate/company";
import PrecificationRulesController from "./PrecificationRulesController.vue";

const defaultPrecification = () => ({
  name: "Precificação Padrão",
  dueDay: 10,
  finePercentage: 2,
  interestPercentage: 1,
  rules: [],
});

export default {
  name: "PrecificationModal",
  components: {
    PrecificationRulesController,
  },
  data: () => ({
    dialog: false,
    loading: false,
    error: null,
    valid: false,
    precification: defaultPrecification(),
  }),
  methods: {
    open(precification) {
      this.dialog = true;
      this.precification = Object.assign(defaultPrecification(), precification);
    },
    close() {
      this.dialog = false;
    },
    async save() {
      try {
        this.loading = true;
        this.error = null;
        const data = await COMPANY.createPrecification(this.company.id, {
          ...this.precification,
        });
        this.close();
        this.$emit("success");
      } catch (error) {
        this.error = error.message || "Erro ao salvar precificação";
      } finally {
        this.loading = false;
      }
    },
  },
  props: {
    company: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    this.$parent.$on("precification-modal", this.open);
  },
  beforeDestroy() {
    this.$parent.$off("precification-modal", this.open);
  },
};
</script>